export const permission={
    diagnosis:{
        getDiagnosisList:'getDiagnosisVersion',
        editDiagnosis:"editDiagnosisVersion",
        getDiagnosisDetails:"getDiagnosis",
        saveDiagnosis:"saveDiagnosis"
    },
    allergy:{
        getAllergyList:'getAllergyVersion',
        editAllergy:"editAllergyVersion",
        getAllergyDetails:"getAllergy",
        saveAllergy:"saveAllergy"
    },
    role:{
        addRole:'addRole',
        updateRole:"updateRole",
        getRoleDetails:'getRoleDetails'
    }
}